export class ClusterNodeGroupContainer {
    constructor(clusterNodeGroups) {
        this._clusterNodeGroups = clusterNodeGroups;
    }
    getClusterNodeGroupsByMode(mode) {
        return this._clusterNodeGroups.filter((clusterNodeGroup) => {
            return clusterNodeGroup.getConnectionMode() === mode;
        });
    }
    getClusterNodeGroupsById(mode, id) {
        const groupsByMode = this.getClusterNodeGroupsByMode(mode);
        if (groupsByMode.length === 0)
            return undefined;
        return this._clusterNodeGroups.find((clusterNodeGroup) => clusterNodeGroup.getNodeID() === id);
    }
}
